export const formatDateTime = (d) => {
    // return moment(d)
    //     .local()
    //     .format("HH:mm:ss (DD/MM/YYYY)");
    let dt = new Date(d);
    if (!(dt instanceof Date && !isNaN(dt))) return '';

    let date =
        dt.getDate().toString().padStart(2, "0") + "/" +
        (dt.getMonth() + 1).toString().padStart(2, "0") + "/" +
        dt.getFullYear().toString().padStart(4, "0");
    let time =
        dt.getHours().toString().padStart(2, "0") + ":" +
        dt.getMinutes().toString().padStart(2, "0") + ":" +
        dt.getSeconds().toString().padStart(2, "0");

    return time + " " + date;
}

export const humanFileSize = (bytes, si = true, dp = 1) => {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(dp) + ' ' + units[u];
}

export const get = (obj, itemName, fallback = null) => {
    if (obj && obj[itemName]) return obj[itemName];
    return fallback;
}